const yesNoLifeInsuranceLosses = {
    yes: 'Oui',
    no: 'Non',
};

export default yesNoLifeInsuranceLosses;
